import { Signal, ValueEqualityFn } from '@angular/core';
import { SingleSelectService } from '../services/selection/single-select.service';
import { ExplorerAddonFactory } from './explorer';

export interface SingleSelectExplorer<T> {
  selected: Signal<T | null>;
  selectedIndex: Signal<number | null>;
  result: Signal<T[]>;
  select(value: T): void;
  unselect(): void;
}

export interface SingleSelectExplorerOptions<T> {
  equals?: ValueEqualityFn<T>
  selectFirst?: boolean;
  keepPreviousSelection?: undefined | 'equality' | 'index';
}

export function withSelect<T>(options?: SingleSelectExplorerOptions<T>): ExplorerAddonFactory<T, SingleSelectExplorer<T>> {
  return (source: Signal<T[]>): SingleSelectExplorer<T> => singleSelect<T>(source, options);
}

function singleSelect<T>(source: Signal<T[]>, options?: SingleSelectExplorerOptions<T>): SingleSelectExplorer<T> {
  const service = new SingleSelectService<T>(source, options);
  return service;
}
